import { Outlet, ScrollRestoration } from 'react-router-dom'

import { AuthLayout } from '@/app/auth/layout'

export const AuthPage = () => (
  <AuthLayout>
    <Outlet />

    <ScrollRestoration />
  </AuthLayout>
)
